var exports = {
  "kL": "x31de4314--072d19--container",
  "iE": "x31de4314--072d19--wrapper",
  "az": "x31de4314--072d19--with-banner",
  "s_": "x31de4314--072d19--with-margin",
  "DD": "x31de4314--072d19--title",
  "Dk": "x31de4314--072d19--carousel",
  "K5": "x31de4314--072d19--carousel--skeleton",
};

module.exports = exports;
